import React, { ReactNode, createContext, useContext } from "react";
import { useFila } from '../context/FilaContext'
import { useDividas } from '../context/DividasContext'
import { useContrato } from '../context/ContratoContext'
import { usePropostas } from '../context/PropostasContext'
import { useHistorico } from '../context/HistoricoContext'
import { useBoleto } from '../context/BoletoContext'
import { useFilaTransbordo } from "../context/FilaTransbordoContext";

interface ClearProviderProps {
  children: ReactNode;
}

interface ClearProps {
  clearData(): void
}

const Clear = createContext<ClearProps>({} as ClearProps);

export const ClearProvider = ({ children }: ClearProviderProps) => {
  const { clearContratos } = useContrato();
  const { clearDividas, clearDevedorCadastro } = useDividas()
  const { clearPropostas } = usePropostas()
  const { clearHistorico } = useHistorico()
  const { clearBoleto } = useBoleto()
  const { clearSelectedFila } = useFila()
  const { clearSelectedFila: clearTransbordo } = useFilaTransbordo()

  function clearData() {
    clearPropostas()
    clearContratos()
    clearHistorico()
    clearBoleto()
    clearDevedorCadastro()
    clearDividas()
    clearSelectedFila()
    clearTransbordo()
  }

  return (
    <Clear.Provider value={{
      clearData
    }}>
      {children}
    </Clear.Provider>
  );
};

export const useClear = () => useContext(Clear);


